import React, { useEffect, useRef, useState, useReducer } from "react";
import ReactDOM from "react-dom";
import eventBus from "../../../../../util/eventBus";
import "./index.less";
import { Icon, Space, Tooltip } from "@kdcloudjs/kdesign";
import "@kdcloudjs/kdesign/dist/kdesign.css";
import { Heart, ItDoesnTHelp } from "@kdcloudjs/kdesign-icons";
import chroma from "chroma-js";

/**
 * 在setHtml中声明Root类，使用ReactDOM.render将其渲染在model.dom中
 * 在Root类的componentDidMount里，声明一个订阅，用于接收后端更新发过来的消息，从而去更新组件
 * 在update里，发布一个消息，当后端插件给自定义控件传递新数据时，就能将消息发布给Root
 * 在Root类的componentWillUnmount里，取消订阅
 * 在destoryed里，使用ReactDOM.unmountComponentAtNode卸载Root
 * 注意loadFile中index.css的引入路径，因为webpack打包后将其放在了css文件夹里，所以路径是./css/index.css
 */

(function (KDApi) {
  function DefaultComponenent(model) {
    this._setModel(model);
  }

  DefaultComponenent.prototype = {
    _setModel: function (model) {
      this.model = model;
      this.I18N = (key) => KDApi.getLangMsg(model, key);
    },
    init: function (props) {
      console.log("-----init", this.model.style, props);
      setHtml(this.model, props, { I18N: this.I18N });
    },
    update: function (props) {
      console.log("-----update", this.model, props);
      eventBus.pub(this.model, "update", props);
    },
    destoryed: function () {
      console.log("-----destoryed", this.model);
      ReactDOM.unmountComponentAtNode(this.model.dom);
    },
  };

  var setHtml = function (model, primaryProps, { I18N }) {
    KDApi.loadFile("./css/index.css", model, () => {
      const Root = (props) => {
        const [model, setModel] = useState(props.model);
        const [data, setData] = useState(props?.customProps?.data);

        const x = {
          tags: ["连续三年高绩效", "部门排名前25%", "绩优群体"],
          years: [
            {
              grade: "A+",
              department: "20%",
              group: "10%",
              year: "2021",
            },
            {
              grade: "A",
              department: "20%",
              group: "10%",
              year: "2020",
            },
            {
              grade: "B+",
              department: "20%", // 部门排名
              group: "10%", // 考核组排名
              year: "2019",
            },
          ],
        };
        useEffect(() => {
          const updateSub = eventBus.sub(model, "update", (customProps) => {
            // setData(customProps?.data?.data);
          });
          return () => {
            eventBus.unsub(updateSub);
          };
        }, []);
        console.log(data);
        const colors = ["#2F90FF", "#23AF48", "#FF7100"];
        const bgColors = [
          "linear-gradient(1deg, rgba(47,144,255,0.17) 0%, #2F90FF 100%)",
          "linear-gradient(1deg, rgba(35,175,72,0.17) 0%, #23AF48 100%)",
          "linear-gradient(1deg, rgba(255,113,0,0.17) 0%, #FF7100 100%)",
        ];
        return (
          <div className="talent-assessement-container">
            <div className="talent-assessment-main">
              <div className="talent-assessment-main-content">
                <Space className="assessment-list">
                  {data.years && data.years.length
                    ? data.years.map(({ year, grade }, index) => (
                        <div className="assessment-item">
                          <div
                            className="item-background"
                            style={{ background: bgColors[index] }}
                          />
                          <div
                            className="item-year"
                            style={{ background: colors[index] }}
                          >
                            {year}
                          </div>
                          <div className="item-grade">{grade}</div>
                        </div>
                      ))
                    : null}
                </Space>
                <div>
                  {data.showDept && (
                    <div className="rate-wrapper">
                      <div className="rate-title">部门排名</div>
                      <div className="rate-list">
                        <div
                          className="standard-rate"
                          style={{ left: `${data.deptExcellentRanking || 0}%` }}
                        >
                          <div>{data.deptExcellentRanking || 0}%</div>
                        </div>

                        {data.years &&
                          data.years.length &&
                          data.years.map(({ department: rate }, index) => (
                            <Tooltip tip={`${rate}%`}>
                              <div
                                className="rate-item"
                                style={{
                                  background: colors[index],
                                  left: `${rate}%`,
                                }}
                              ></div>
                            </Tooltip>
                          ))}
                      </div>
                    </div>
                  )}
                  {data.showGroup && (
                    <div className="rate-wrapper">
                      <div className="rate-title">考核组排名</div>
                      <div className="rate-list">
                        <div
                          className="standard-rate"
                          style={{
                            left: `${data.groupExcellentRanking || 0}%`,
                          }}
                        >
                          <div>{data.groupExcellentRanking || 0}%</div>
                        </div>
                        {data.years &&
                          data.years.length &&
                          data.years.map(({ group: rate }, index) => (
                            <Tooltip tip={`${rate}%`}>
                              <div
                                className="rate-item"
                                style={{
                                  background: colors[index],
                                  left: `${rate}%`,
                                }}
                              ></div>
                            </Tooltip>
                          ))}
                      </div>
                    </div>
                  )}
                </div>

                <div className="tag-warpper">
                  {data.tags && data.tags.length
                    ? data.tags.map((tag) => (
                        <div className="tag-item">
                          <div>{tag}</div>
                        </div>
                      ))
                    : null}
                </div>
              </div>
            </div>
          </div>
        );
      };

      ReactDOM.render(
        <Root model={model} customProps={primaryProps} I18N={I18N} />,
        model.dom
      );
    });
  };

  // 注册自定义组件
  KDApi.register("talentAssessment", DefaultComponenent, { isMulLang: true });
})(window.KDApi);
